define("shared/components/shared/color-picker/header", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--dropHeader {{unless @menuTitle 'no--title'}}">
    <h4 class="o--dropHeader__title u--p__l__xs">
      {{@menuTitle}}
    </h4>
    <Shared::Ui::Button
      @onClick={{@close}}
      @size="small"
      @variant="unstyled"
      class={{concat-classes "o--dropHeader__close" @qaClass}}
      data-test-id="close-menu"
    >
      {{svg-jar "close" class="o--icon"}}
    </Shared::Ui::Button>
  </div>
  */
  {
    "id": "xU0QTuh5",
    "block": "[[[10,0],[15,0,[29,[\"o--dropHeader \",[52,[51,[30,1]],\"no--title\"]]]],[12],[1,\"\\n  \"],[10,\"h4\"],[14,0,\"o--dropHeader__title u--p__l__xs\"],[12],[1,\"\\n    \"],[1,[30,1]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[8,[39,1],[[16,0,[28,[37,2],[\"o--dropHeader__close\",[30,2]],null]],[24,\"data-test-id\",\"close-menu\"]],[[\"@onClick\",\"@size\",\"@variant\"],[[30,3],\"small\",\"unstyled\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,3],[\"close\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13]],[\"@menuTitle\",\"@qaClass\",\"@close\"],false,[\"unless\",\"shared/ui/button\",\"concat-classes\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/color-picker/header.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});